<template>
  <div class="access">
    <!-- 头部 -->
    <div class="header">
      <div class="left">
        <img src="../assets/logo3.png" />
        <div>四川卓远企业征信咨询有限公司</div>
      </div>
      <div class="right">
        <el-dropdown @command="handleCommand">
          <div class="info">
            <img size="small" src="../assets/user11.png" />
            <div class="name">{{ name }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="myWarranty">我的</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- 企业信息 -->
    <el-card class="margin-top">
      <el-descriptions title="企业信息" :column="3" border>
        <template slot="extra">
          <el-button
            type="primary"
            size="small"
            @click="updateEnterpriseInfo(enterpriseInfo)"
            >修改企业信息</el-button
          >
        </template>
        <el-descriptions-item label="企业名称">{{
          enterpriseInfo?.enterpriseName
        }}</el-descriptions-item>
        <el-descriptions-item label="企业信用代码">{{
          enterpriseInfo?.enterpriseCreditCode
        }}</el-descriptions-item>
        <el-descriptions-item label="企业法人">{{
          enterpriseInfo?.juridicalPerson
        }}</el-descriptions-item>
        <el-descriptions-item label="所属行业">{{
          enterpriseInfo?.categoryStr
        }}</el-descriptions-item>
        <el-descriptions-item label="企业经办人">{{
          enterpriseInfo?.enterpriseOperator
        }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{
          enterpriseInfo?.enterpriseOperatorPhone
        }}</el-descriptions-item>
        <el-descriptions-item label="企业性质">{{
          enterpriseInfo?.enterpriseNature==0?'其他':enterpriseInfo?.enterpriseNature==1?'国有企业':enterpriseInfo?.enterpriseNature==2?'集体所有制':enterpriseInfo?.enterpriseNature==3?'私营企业':enterpriseInfo?.enterpriseNature==4?'股份制企业':enterpriseInfo?.enterpriseNature==5?'有限合伙人企业':enterpriseInfo?.enterpriseNature==6?'联营企业':enterpriseInfo?.enterpriseNature==7?'外商投资企业':enterpriseInfo?.enterpriseNature==8?'个人独资企业':''
        }}</el-descriptions-item>
        <el-descriptions-item label="企业注册地">{{
          enterpriseInfo?.enterpriseRegistrationPlace
        }}</el-descriptions-item>
        <el-descriptions-item label="详细地址">{{
          enterpriseInfo?.enterpriseAddress
        }}</el-descriptions-item>
        <el-descriptions-item label="企业基本账户">{{
          enterpriseInfo?.enterpriseAccountNo
        }}</el-descriptions-item>
        <el-descriptions-item label="开户银行">{{
          enterpriseInfo?.enterpriseCardNo
        }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-drawer
      title="修改企业信息"
      :visible.sync="isVisible"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form :model="formInline" ref="formInline" class="demo-form-inline">
        <el-form-item
          label="企业名称"
          prop="enterpriseName"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseName"
            placeholder="企业名称"
            style="width: 350px"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          label="企业信用代码"
          prop="enterpriseCreditCode"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseCreditCode"
            placeholder="企业信用代码"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="企业法人"
          prop="juridicalPerson"
          label-width="110px"
        >
          <el-input
            v-model="formInline.juridicalPerson"
            placeholder="企业法人"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item label="所属行业" prop="categoryStr" label-width="110px">
          <el-input
            v-model="formInline.categoryStr"
            placeholder="所属行业"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="企业经办人"
          prop="enterpriseOperator"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseOperator"
            placeholder="企业经办人"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="联系电话"
          prop="enterpriseOperatorPhone"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseOperatorPhone"
            placeholder="联系电话"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="企业性质"
          prop="enterpriseNature"
          label-width="110px"
        >
          <el-select
            v-model="formInline.enterpriseNature"
            placeholder="请选择企业性质"
            clearable
            style="width: 350px"
          >
            <el-option
              v-for="dict in enterpriseList"
              :key="dict.dictValue"
              :label="dict.dictLabel"
              :value="dict.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="企业注册地"
          prop="enterpriseRegistrationPlace"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseRegistrationPlace"
            placeholder="企业注册地"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="详细地址"
          prop="enterpriseAddress"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseAddress"
            placeholder="详细地址"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="企业基本账户"
          prop="enterpriseAccountNo"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseAccountNo"
            placeholder="企业基本账户"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="开户银行"
          prop="enterpriseCardNo"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseCardNo"
            placeholder="开户银行"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="margin-left: 30%" @click="handleClose"
            >取消</el-button
          >
          <el-button type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <!-- 我的项目搜索 -->
    <!-- <el-card class="search-card">
      <el-form :inline="true" :model="searchParams" ref="searchFormRef">
        <el-form-item label="项目名称" prop="entryName">
          <el-input
            v-model="searchParams.entryName"
            placeholder="请输入项目名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="querySubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card> -->

    <!-- 我的项目 -->
    <div class="box-title">
      <div class="wire"></div>
      <div class="title">我的项目</div>
    </div>

    <el-card class="insurance" v-for="item in myInsuranceList" :key="item.id">
      <div class="insurance-title">
        <img src="../assets/logo1.png" />
        <div class="insurance-box">
          <div class="title">{{ item.entryName }}</div>
          <div class="serial">保险公司名称：{{ item.insuranceCompany }}</div>
          <div class="section">
            <div class="name">标段名称：{{ item.lot }}</div>
            <div>标段编号：{{ item.policyNo }}</div>
          </div>
          <div class="section">
            <div class="name">保险金额(元)：{{ item.premium }}</div>
            <div>投保时间：{{ item.startTime }}</div>
          </div>
          <div class="btn">
            <el-popconfirm
              icon="el-icon-info"
              icon-color="red"
              title="确定将此表单作废吗？"
              @confirm="handleCancellation(item)"
              style="margin-right: 10px"
            >
              <el-button slot="reference" size="mini" type="primary"
                >作废表单</el-button
              >
            </el-popconfirm>
            <el-button
              type="primary"
              size="mini"
              @click.stop="handleInvoice(item.policyUrl)"
              >申请开票</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click.stop="handleUpload(item.policyUrl)"
              >保单下载</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click.stop="handleRefund(item.entryNo)"
              >{{ item.status == 2 ? "退款中" : "申请退款" }}</el-button
            >
          </div>
        </div>
      </div>
    </el-card>
    <div class="footer">
      <Pagination
        ref="pagination"
        :propCurrentPage="page"
        :propPageSize="pageSize"
        :callback="getMyInsuranceList"
        :total="total"
      >
        >
      </Pagination>
    </div>

    <!-- tabs选择 -->
    <div class="tabs">
      <div class="tabs-box" @click="handleToUrl">
        <div class="title">
          <div>项目选择</div>
          <img src="../assets/list.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
export default {
  name: "Access",
  components: { Pagination },
  data() {
    return {
      total: 0,
      page: 1,
      pageSize: 10,
      searchParams: {},
      myInsuranceList: [],
      enterpriseInfo: {},
      isVisible: false,
      formInline: {},
      enterpriseList: [],
      name:  window.sessionStorage.getItem("enterpriseName")
    };
  },
  mounted() {
    this.getMyInsuranceList();
    this.getEnterpriseList();
    this.getEnterpriseInfoList();
  },
  methods: {
    // 点击头像 退出登录
    handleCommand(command) {
      if (command === "logout") {
        this.logout();
      }
      if (command === "myWarranty") {
        this.myWarranty();
      }
    },
    // 我的
    myWarranty() {
      this.$router.push("/my");
    },
    // 退出登录
    logout() {
      window.sessionStorage.clear();
      this.$router.push("/");
    },
    // 跳转项目列表
    handleToUrl() {
      this.$router.push("/access");
    },
    // 重置搜索框
    resetForm() {
      this.$refs.searchFormRef.resetFields();
      this.getMyInsuranceList();
    },
    // 作废保单
    async handleCancellation(item) {
      const params = {
        id: item.entryNo,
        status: 3,
      };
      const { data: res } = await this.$http.post(
        "Insurance/information/remove",
        params
      );
      if (res.code === 200) {
        this.$message.success("保单已作废");
        this.getMyInsuranceList();
      } else {
        this.$message.error(res.msg);
      }
    },
    // 申请开票
    handleInvoice() {
      this.$message.success("开票成功");
    },
    // 保单下载
    handleUpload(url) {
      window.open(url);
    },
    // 退款
    async handleRefund(id) {
      const params = {
        id,
        status: 2,
      };
      const { data: res } = await this.$http.post(
        "Insurance/information/edit1",
        params
      );
      if (res.code === 200) {
        this.$message.success("退款成功");
        this.getMyInsuranceList();
      } else {
        this.$message.error(res.msg);
      }
    },
    // 查询我的项目列表
    querySubmit() {
      this.getMyInsuranceList(this.searchParams);
    },
    // 我的项目列表
    async getMyInsuranceList(searchVal, page = 1, pageSize = 10) {
      const { data: res } = await this.$http.post(
        `Insurance/information/list1?status=1&pageNum=${page}&pageSize=${pageSize}&entryName=${
          searchVal != undefined ? searchVal.entryName : " "
        }`
      );
      if (res.code === 200) {
        this.myInsuranceList = res.rows;
        this.total = res.total;
      }
    },
    // 企业信息
    async getEnterpriseInfoList() {
      const id = window.sessionStorage.getItem("id");

      const { data: res } = await this.$http.get(
        `Insurance/applicant/list1?id=${id}`
      );
      if (res.code === 200) {
        res.data.enterpriseNature = res.data.enterpriseNature + ''
        this.enterpriseInfo = res.data;
        window.sessionStorage.setItem(
          "enterpriseName",
          res.data.enterpriseName
        );
        window.sessionStorage.setItem(
          "enterpriseCreditCode",
          res.data.enterpriseCreditCode
        );
        window.sessionStorage.setItem(
          "juridicalPerson",
          res.data.juridicalPerson
        );
        window.sessionStorage.setItem("categoryStr", res.data.categoryStr);
        window.sessionStorage.setItem(
          "enterpriseOperator",
          res.data.enterpriseOperator
        );
        window.sessionStorage.setItem(
          "enterpriseOperatorPhone",
          res.data.enterpriseOperatorPhone
        );
        window.sessionStorage.setItem(
          "enterpriseNature",
          res.data.enterpriseNature
        );
        window.sessionStorage.setItem(
          "enterpriseRegistrationPlace",
          res.data.enterpriseRegistrationPlace
        );
        window.sessionStorage.setItem(
          "enterpriseAddress",
          res.data.enterpriseAddress
        );
        window.sessionStorage.setItem(
          "enterpriseAccountNo",
          res.data.enterpriseAccountNo
        );
        window.sessionStorage.setItem(
          "enterpriseCardNo",
          res.data.enterpriseCardNo
        );
      }
    },
    // 企业性质列表
    async getEnterpriseList() {
      const { data: res } = await this.$http.post(
        `system/dict/data/list1?dictType=enterprise_nature`
      );
      if (res.code === 200) {
        this.enterpriseList = res.rows;
      }
    },
    // 修改企业信息
    updateEnterpriseInfo(item) {
      this.isVisible = true;
      this.formInline = item;
    },
    // 关闭弹窗
    handleClose() {
      this.isVisible = false;
    },
    async submit() {
      this.formInline.id = window.sessionStorage.getItem("id");

      const { data: res } = await this.$http.post(
        `Insurance/applicant/edit1`,
        this.formInline
      );
      if (res.code === 200) {
        this.$message.success("修改成功");
        this.formInline = res.data;
        this.isVisible = false;
        window.sessionStorage.setItem(
          "enterpriseName",
          res.data.enterpriseName
        );
        window.sessionStorage.setItem(
          "enterpriseCreditCode",
          res.data.enterpriseCreditCode
        );
        window.sessionStorage.setItem(
          "juridicalPerson",
          res.data.juridicalPerson
        );
        window.sessionStorage.setItem("categoryStr", res.data.categoryStr);
        window.sessionStorage.setItem(
          "enterpriseOperator",
          res.data.enterpriseOperator
        );
        window.sessionStorage.setItem(
          "enterpriseOperatorPhone",
          res.data.enterpriseOperatorPhone
        );
        window.sessionStorage.setItem(
          "enterpriseNature",
          res.data.enterpriseNature
        );
        window.sessionStorage.setItem(
          "enterpriseRegistrationPlace",
          res.data.enterpriseRegistrationPlace
        );
        window.sessionStorage.setItem(
          "enterpriseAddress",
          res.data.enterpriseAddress
        );
        window.sessionStorage.setItem(
          "enterpriseAccountNo",
          res.data.enterpriseAccountNo
        );
        window.sessionStorage.setItem(
          "enterpriseCardNo",
          res.data.enterpriseCardNo
        );
      }
    },
  },
};
</script>

<style lang="scss">
.access {
  width: 100%;
  position: relative;

  .tabs {
    position: fixed;
    top: 50%;
    right: 20px;
    width: 80px;
    background: #fff;
    border-radius: 5px;
    text-align: center;
    -webkit-box-shadow: 3px 6px 16px rgb(0 0 0 / 20%);
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);

    .tabs-box {
      .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100px;
        cursor: pointer;
        border-bottom: 1px solid #f1f1f1;
        &.active {
          background: #f1f1f1;
        }
      }

      img {
        width: 30px;
        height: 30px;
        margin-top: 9px;
      }
    }
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    height: 80px;
    margin: 0 auto 20px;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 50px;
        height: 40px;
        margin-right: 5px;
      }
      div {
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
      }
    }
    .right {
      display: flex;
      align-items: center;
      .info {
        display: flex;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
        }
        .name {
          margin-left: 10px;
        }
      }
    }
  }

  .margin-top {
    width: 1200px;
    height: 280px;
    margin: 30px auto 30px;
  }

  .search-card {
    width: 1200px;
    height: 80px;
    margin: 0 auto 10px;
  }
  .box-title {
    display: flex;
    align-items: center;
    width: 1200px;
    height: 40px;
    margin: 0 auto 10px;
    .wire {
      width: 4px;
      height: 25px;
      background: #3f74dc;
    }
    .title {
      margin-left: 10px;
      font-size: 18px;
    }
  }
  .insurance {
    width: 1200px;
    height: 200px;
    margin: 0 auto 20px;
    .insurance-title {
      display: flex;
      width: 100%;
      height: 60px;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
      .insurance-box {
        width: 100%;
        height: 100%;
        .title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 5px;
        }
        .serial {
          color: #999;
          margin-bottom: 20px;
        }
        .section {
          display: flex;
          align-items: center;
          color: #999;
          margin-bottom: 10px;
          .name {
            margin-right: 20px;
          }
        }
        .btn {
          display: flex;
          justify-content: end;
        }
      }
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: end;
    width: 1200px;
    height: 100px;
    margin: 0 auto;
  }
}
</style> 